import React, { memo, useCallback } from 'react'

import { Toggle } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

function ToggleRow({ id, label, isChecked = false, onChange }) {
  const handleChange = useCallback((event, nextChecked) => {
    onChange(nextChecked)
  }, [onChange])

  return (
    <Toggle
      id={id}
      className="notifications-popover__toggle"
      labelClassName="notifications-popover__toggle-row"
      label={<span className="cgt-body-base-semibold">{label}</span>}
      size="small"
      isChecked={isChecked}
      onChange={handleChange}
    />
  )
}

ToggleRow.propTypes = {
  id: string.isRequired,
  label: string.isRequired,
  isChecked: bool,
  onChange: func.isRequired,
}

export default memo(ToggleRow)
